"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnDefParams = void 0;
/* eslint-disable @typescript-eslint/no-inferrable-types */
const constants_1 = require("./constants");
/**
 * Represents the default inputs for a data table header.
 */
class ColumnDefParams {
    constructor() {
        /**
         * The unique identifier for the header.
         */
        this.idx = `${Math.floor(Math.random() * 10000)}`;
        /**
         * The field name of the header from row data object.
         */
        this.field = '';
        /**
         * The data type of the header.
         * @default 'text'
         */
        this.dataType = 'text';
        /**
         * Indicates whether the header is hidden.
         * @default false
         */
        this.isHidden = false;
        /**
         * The text alignment of the header.
         * @default AlignmentOpts.LEFT
         */
        this.textAlignment = constants_1.AlignmentOpts.LEFT;
    }
}
exports.ColumnDefParams = ColumnDefParams;
//# sourceMappingURL=column-def.params.js.map